export default __webpack_public_path__ + "static/media/hmy_work2.3caedc37.jpg";